<div class="main-content table-page parametros-page parametros-bsc">
  <div class="container-fluid">
    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1>Parámetros y reglas del BSC</h1>
        <p>Por año. Un año nuevo hereda los valores del anterior; lo que guardes aplica solo al año elegido.</p>
      </div>
      <div class="table-page__toolbar-actions">
        <button type="button" mat-raised-button class="btn table-page__primary-btn"
                [disabled]="guardando || guardandoIndicadores || loading || !ciclo || cerrado" (click)="guardar()">
          <span class="material-icons" aria-hidden="true">save</span>
          {{ guardando ? "Guardando…" : "Guardar" }}
        </button>
      </div>
    </section>

    <app-selector-corte-bsc prefijo="bsc-parametros" [mostrarCorte]="false" [incluirSiguiente]="true"
                            [deshabilitado]="loading || guardando || guardandoArea || cerrando || guardandoIndicadores"
                            (cambio)="onSeleccion($event)">
      <div meta class="tickets-toolbar__meta" *ngIf="ciclo && !loading">
        <span>{{ textoOrigen }} · {{ ciclo.versionFormato || "FOR-011" }}</span>
        <strong><span [class]="claseEstatus">{{ textoEstatus }}</span></strong>
      </div>
    </app-selector-corte-bsc>

    <section class="table-page__card" *ngIf="loading">
      <div class="table-page__empty">
        <span class="material-icons" aria-hidden="true">hourglass_top</span>
        <h3>Consultando parámetros</h3>
        <p>Espere un momento.</p>
      </div>
    </section>

    <section class="table-page__card" *ngIf="!loading && error">
      <div class="table-page__empty">
        <span class="material-icons" aria-hidden="true">lock_outline</span>
        <h3>No se pudieron consultar los parámetros</h3>
        <p>{{ error }}</p>
      </div>
    </section>

    <ng-container *ngIf="!loading && !error && ciclo">
      <output class="parametros-bsc__aviso" *ngIf="heredado">
        <span class="material-icons" aria-hidden="true">content_copy</span>
        <span>{{ textoHerencia }} Pulsa Guardar para crear el ciclo {{ anio }}.</span>
      </output>

      <output class="parametros-bsc__aviso" *ngIf="cerrado">
        <span class="material-icons" aria-hidden="true">lock</span>
        <span>{{ anio }} está cerrado: sus parámetros son de solo lectura.</span>
      </output>

      <app-indicadores-norma-bsc [anio]="anio" [areas]="areas" [soloLectura]="cerrado || heredado"
        (guardandoCambio)="guardandoIndicadores = $event"></app-indicadores-norma-bsc>

      <!-- ============================ Semáforo y umbral ============================ -->
      <section class="table-page__card parametros-page__bloque">
        <header class="parametros-page__encabezado">
          <h2>Semáforo y umbral</h2>
          <p>
            Qué tan cerca de lo programado acumulado está un KPI o un área para leerse en meta, en riesgo o
            fuera. Debajo de «en riesgo» es rojo.
          </p>
        </header>

        <div class="parametros-page__grid">
          <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
            <mat-label>En meta desde (%)</mat-label>
            <input matInput type="number" min="0" max="100" step="0.1" [(ngModel)]="forma.verde"
                   aria-label="En meta desde (%)" [disabled]="umbralesDeshabilitados" />
            <mat-hint *ngIf="umbralesBloqueados">Bloqueado: hay trimestres autorizados.</mat-hint>
            <mat-hint *ngIf="!umbralesBloqueados">Verde: real acumulado ≥ este % de lo programado.</mat-hint>
          </mat-form-field>

          <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
            <mat-label>En riesgo desde (%)</mat-label>
            <input matInput type="number" min="0" max="100" step="0.1" [(ngModel)]="forma.amarillo"
                   aria-label="En riesgo desde (%)" [disabled]="umbralesDeshabilitados" />
            <mat-hint *ngIf="umbralesBloqueados">Bloqueado: hay trimestres autorizados.</mat-hint>
            <mat-hint *ngIf="!umbralesBloqueados">Amarillo; menor que «en meta».</mat-hint>
          </mat-form-field>

          <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
            <mat-label>Objetivo Solser anual (%)</mat-label>
            <input matInput type="number" min="0" max="100" step="0.1" [(ngModel)]="forma.objetivo"
                   aria-label="Objetivo Solser anual (%)" [disabled]="umbralesDeshabilitados" />
            <mat-hint *ngIf="umbralesBloqueados">Bloqueado: hay trimestres autorizados.</mat-hint>
            <mat-hint *ngIf="!umbralesBloqueados">Umbral gerencial de la empresa. Cada Q puede tener el suyo abajo.</mat-hint>
          </mat-form-field>
        </div>

        <ul class="parametros-bsc__bloqueos" *ngIf="bloqueos.length > 0">
          <li *ngFor="let bloqueo of bloqueos">
            <span class="material-icons" aria-hidden="true">lock</span>
            {{ bloqueo }}
          </li>
        </ul>
      </section>

      <!-- ============================ Fechas del ciclo ============================ -->
      <section class="table-page__card parametros-page__bloque">
        <header class="parametros-page__encabezado">
          <h2>Fechas del ciclo {{ anio }}</h2>
          <p>
            Cuándo vence cada paso del trimestre. Una fecha vacía nunca vence ni genera recordatorio; el objetivo
            del trimestre vacío usa el anual.
          </p>
        </header>

        <div class="table-page__table-wrap parametros-bsc__fechas-wrap">
          <table class="table-page__table parametros-bsc__fechas">
            <thead>
              <tr>
                <th>Trimestre</th>
                <th *ngFor="let fecha of fechasTrimestre">{{ fecha.texto }}</th>
                <th>Objetivo del Q (%)</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let t of trimestres">
                <td><strong class="table-page__name">Q{{ t.trimestre }}</strong></td>
                <td *ngFor="let fecha of fechasTrimestre">
                  <mat-form-field appearance="outline" class="table-page__field parametros-bsc__celda" subscriptSizing="dynamic">
                    <input matInput type="date" [(ngModel)]="t[fecha.campo]" [disabled]="cerrado"
                           [attr.aria-label]="fecha.texto + ' Q' + t.trimestre" />
                  </mat-form-field>
                </td>
                <td>
                  <mat-form-field appearance="outline" class="table-page__field parametros-bsc__celda parametros-bsc__celda--corta"
                                  subscriptSizing="dynamic">
                    <input matInput type="number" min="0" max="100" step="0.1" [(ngModel)]="t.objetivo"
                           [disabled]="umbralesDeshabilitados" [placeholder]="umbralesBloqueados ? 'Bloqueado' : 'Anual'"
                           [attr.title]="umbralesBloqueados ? 'Bloqueado: hay trimestres autorizados.' : null"
                           [attr.aria-describedby]="umbralesBloqueados ? 'bsc-parametros-objetivo-q-bloqueado' : null"
                           [attr.aria-label]="'Objetivo Solser Q' + t.trimestre" />
                  </mat-form-field>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <p class="parametros-page__nota parametros-bsc__nota-tabla" id="bsc-parametros-objetivo-q-bloqueado"
           *ngIf="umbralesBloqueados">
          Objetivo de cada Q bloqueado: hay trimestres autorizados.
        </p>

        <div class="parametros-page__grid">
          <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
            <mat-label>Día límite de captura mensual</mat-label>
            <input matInput type="number" min="1" max="28" [(ngModel)]="forma.diaLimite" [disabled]="cerrado"
                   aria-label="Día límite de captura mensual" />
            <mat-hint>Del mes siguiente: la captura de marzo vence el día {{ forma.diaLimite || "…" }} de abril.</mat-hint>
          </mat-form-field>

          <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
            <mat-label>Recordar con anticipación (días)</mat-label>
            <input matInput type="number" min="0" [max]="anticipacionMax" step="1" [(ngModel)]="forma.anticipacion"
                   aria-label="Recordar con anticipación (días)" [disabled]="cerrado" />
            <mat-hint>De 0 a {{ anticipacionMax }} días antes de cada fecha en que llega el recordatorio a la campana.</mat-hint>
          </mat-form-field>
        </div>
      </section>

      <!-- ============================ Reglas ============================ -->
      <section class="table-page__card parametros-page__bloque">
        <header class="parametros-page__encabezado">
          <h2>Reglas de cálculo y cierre</h2>
          <p>Cómo se promedia un área y qué se le exige para enviar su trimestre a revisión.</p>
        </header>

        <div class="parametros-page__toggles">
          <mat-slide-toggle [(ngModel)]="forma.excluirKpiNa" [disabled]="umbralesDeshabilitados"
                            [attr.aria-describedby]="umbralesBloqueados ? 'bsc-parametros-na-bloqueado' : null">
            Los KPI marcados «NA» no cuentan en el promedio del área hasta el trimestre en que aplican
          </mat-slide-toggle>
          <p class="parametros-page__nota" id="bsc-parametros-na-bloqueado" *ngIf="umbralesBloqueados">
            Bloqueado: hay trimestres autorizados.
          </p>
        </div>

        <div class="parametros-page__toggles">
          <mat-slide-toggle [(ngModel)]="forma.exigirSumaPesos" [disabled]="cerrado">
            Exigir que los pesos de los 4 trimestres de cada KPI sumen 100 %
          </mat-slide-toggle>
        </div>

        <div class="parametros-page__grid" *ngIf="forma.exigirSumaPesos">
          <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
            <mat-label>Tolerancia (puntos %)</mat-label>
            <input matInput type="number" min="0" max="99.9" step="0.1" [(ngModel)]="forma.toleranciaPts"
                   aria-label="Tolerancia (puntos %)" [disabled]="cerrado" />
            <mat-hint>0.5 acepta de 99.5 % a 100.5 %. Menos de 100 puntos.</mat-hint>
          </mat-form-field>
        </div>

        <div class="parametros-page__toggles">
          <mat-slide-toggle [(ngModel)]="forma.exigirMeses" [disabled]="cerrado">
            Exigir los 3 meses capturados en cada KPI para cerrar el trimestre
          </mat-slide-toggle>
          <p class="parametros-page__nota">
            Metas y pesos se fijan en la planeación anual de cada área y no cambian después de autorizarse: esa
            regla no se configura.
          </p>
        </div>
      </section>

      <!-- ============================ Recalcular snapshots (F7.2) ============================ -->
      <section class="table-page__card parametros-page__bloque" *ngIf="puedeRecalcular">
        <header class="parametros-page__encabezado parametros-bsc__encabezado-acciones">
          <div>
            <h2>Snapshots de los trimestres importados</h2>
            <p>
              {{ anio }} se importó del FOR-011. {{ textoRecalculables }} Si cambias el semáforo o la regla NA,
              recalcúlalos para que el tablero, el detalle del área, el comparativo y el FOR-011 exportado usen los
              parámetros guardados. El objetivo Solser no forma parte del snapshot.
            </p>
          </div>
          <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary"
                  [disabled]="recalculando || guardando || snapshotsRecalculables === 0" (click)="recalcular()">
            <span class="material-icons" aria-hidden="true">refresh</span>
            {{ recalculando ? "Recalculando…" : "Recalcular snapshots" }}
          </button>
        </header>
        <output class="parametros-page__nota parametros-bsc__relleno d-block" *ngIf="anioSinGuardar">
          Hay cambios sin guardar: el recálculo usa los parámetros guardados. Pulsa Guardar antes de recalcular.
        </output>
        <ul class="parametros-bsc__lista parametros-bsc__resultado" *ngIf="resultadoRecalculo.length > 0"
            aria-label="Resultado del recálculo">
          <li *ngFor="let r of resultadoRecalculo">
            <span class="material-icons" aria-hidden="true">history</span>
            {{ r }}
          </li>
        </ul>
        <div class="parametros-bsc__relleno" *ngIf="!anioSinGuardar && resultadoRecalculo.length === 0"></div>
      </section>
    </ng-container>

    <!-- ============================ Áreas ============================ -->
    <section class="table-page__card parametros-page__bloque" *ngIf="!loading && !error && ciclo">
      <header class="parametros-page__encabezado parametros-bsc__encabezado-acciones">
        <div>
          <h2>Áreas participantes y vía de captura</h2>
          <p>
            No dependen del año. El nombre es el de la celda «Área:» del FOR-011; los alias son otras formas en que
            aparece.
          </p>
        </div>
        <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary"
                id="bsc-area-agregar" [disabled]="!!edicion" (click)="nuevaArea()">
          <span class="material-icons" aria-hidden="true">add</span>
          Agregar área
        </button>
      </header>

      <!-- Alta (o un área que ya no vino en la tabla): arriba de la tabla, a la vista del botón. -->
      <div class="parametros-bsc__editor-arriba" *ngIf="edicion?.arriba">
        <ng-container *ngTemplateOutlet="editorArea"></ng-container>
      </div>

      <div class="table-page__table-wrap parametros-bsc__areas-wrap" *ngIf="areas.length > 0; else areasVacias">
        <table class="table-page__table">
          <thead>
            <tr>
              <th>Área</th>
              <th>Área COS</th>
              <th>Usuarios</th>
              <th>Vía de captura</th>
              <th>Estatus</th>
              <th class="table-page__actions-head">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let area of areas; trackBy: trackArea">
              <tr [class.is-selected]="edicion?.area?.idBscArea === area.idBscArea && area.idBscArea != null">
                <td>
                  <div class="table-page__cell-stack">
                    <strong class="table-page__name">{{ area.nombre }}</strong>
                    <span class="table-page__subtext" *ngIf="aliasDe(area).length > 0">
                      También: {{ aliasDe(area).join(" · ") }}
                    </span>
                  </div>
                </td>
                <td><span class="table-page__text">{{ nombreAreaCos(area) }}</span></td>
                <td>
                  <div class="table-page__cell-stack" *ngIf="usuariosDe(area).length > 0; else sinUsuarios">
                    <span class="table-page__text" *ngFor="let u of usuariosDe(area)">
                      {{ u.usuario || "Usuario " + u.idUsuario }}
                      <span class="table-page__subtext parametros-bsc__rol">&nbsp;· {{ textoRol(u.rol) }}</span>
                    </span>
                  </div>
                  <ng-template #sinUsuarios>
                    <span class="table-page__status-badge is-pending">Sin asignar</span>
                  </ng-template>
                </td>
                <td><span class="table-page__text">{{ textoVia(area.viaCaptura) }}</span></td>
                <td>
                  <span class="table-page__status-badge"
                        [ngClass]="area.estatus === 'INACTIVO' ? 'is-inactive' : 'is-active'">
                    {{ area.estatus === "INACTIVO" ? "Inactiva" : "Activa" }}
                  </span>
                </td>
                <td class="table-page__actions">
                  <button type="button" class="table-page__action-btn" title="Editar"
                          [id]="'bsc-area-editar-' + area.idBscArea"
                          [attr.aria-label]="'Editar el área ' + area.nombre"
                          [attr.aria-expanded]="area.idBscArea != null && edicion?.area?.idBscArea === area.idBscArea"
                          [disabled]="!!edicion" (click)="editarArea(area)">
                    <span class="material-icons" aria-hidden="true">edit</span>
                  </button>
                </td>
              </tr>
              <!-- Edición: el editor se abre como renglón justo debajo del área. -->
              <tr class="parametros-bsc__fila-editor"
                  *ngIf="edicion && !edicion.arriba && area.idBscArea != null && edicion.area.idBscArea === area.idBscArea">
                <td colspan="6">
                  <ng-container *ngTemplateOutlet="editorArea"></ng-container>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>

      <ng-template #areasVacias>
        <div class="table-page__empty" *ngIf="!edicion">
          <span class="material-icons" aria-hidden="true">groups</span>
          <h3>No hay áreas configuradas</h3>
          <p>Agrega cada área que entrega su FOR-011, con su responsable.</p>
        </div>
      </ng-template>

      <!-- Editor del área: alta o edición, con la lista completa de usuarios. Se pinta arriba de la tabla
           (alta) o en el renglón del área (edición); un solo markup para las dos. -->
      <ng-template #editorArea>
        <fieldset class="parametros-bsc__editor" id="bsc-area-editor" aria-labelledby="bsc-area-editor-titulo"
                  *ngIf="edicion as e">
          <h3 class="parametros-bsc__editor-titulo" id="bsc-area-editor-titulo">
            {{ e.area.idBscArea ? "Editar " + (e.area.nombre || "área") : "Nueva área" }}
          </h3>

          <div class="parametros-page__grid">
            <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
              <mat-label>Nombre (como en el FOR-011)</mat-label>
              <input matInput id="bsc-area-nombre" maxlength="80" required [(ngModel)]="e.area.nombre"
                     aria-label="Nombre (como en el FOR-011)" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
              <mat-label>Alias en el Excel</mat-label>
              <input matInput maxlength="200" [(ngModel)]="e.area.aliasExcel" placeholder="Comercial|Marketing"
                     aria-label="Alias en el Excel" />
              <mat-hint>Separados por «|». Sirven para reconocer el área al cargar el Excel.</mat-hint>
            </mat-form-field>

            <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
              <mat-label>Área COS</mat-label>
              <mat-select [(ngModel)]="e.area.idArea">
                <mat-option [value]="null">Sin ligar</mat-option>
                <mat-option *ngFor="let a of e.opcionesAreaCos; trackBy: trackAreaCos" [value]="a.id">{{ a.area }}</mat-option>
              </mat-select>
              <mat-hint>Opcional: el área del organigrama que corresponde.</mat-hint>
            </mat-form-field>

            <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
              <mat-label>Vía de captura</mat-label>
              <mat-select [(ngModel)]="e.area.viaCaptura">
                <mat-option *ngFor="let v of vias; trackBy: trackValor" [value]="v.valor">{{ v.texto }}</mat-option>
              </mat-select>
              <mat-hint>Si sube su Excel, captura en el flujo guiado o ambas.</mat-hint>
            </mat-form-field>

            <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
              <mat-label>Orden</mat-label>
              <input matInput type="number" min="0" [(ngModel)]="e.area.orden" aria-label="Orden" />
              <mat-hint>En tablero y listas.</mat-hint>
            </mat-form-field>
          </div>

          <div class="parametros-page__toggles">
            <mat-slide-toggle [(ngModel)]="e.activa">Área activa</mat-slide-toggle>
            <p class="parametros-page__nota">Una área inactiva no aparece en el tablero ni en la carga del Excel.</p>
          </div>

          <div class="parametros-bsc__usuarios">
            <div class="parametros-bsc__usuario" *ngFor="let f of e.filas; let i = index; trackBy: trackFila">
              <mat-form-field appearance="outline" class="table-page__field parametros-bsc__usuario-nombre"
                              subscriptSizing="dynamic">
                <mat-label>Persona {{ i + 1 }}</mat-label>
                <!-- Al cerrar con Esc o con clic fuera, el foco regresa al select y no se pierde con el buscador. -->
                <mat-select #persona="matSelect" [id]="'bsc-area-persona-' + i" [ngModel]="f.usuario.idUsuario"
                            (ngModelChange)="eligePersona(e, f, $event)" (openedChange)="$event || persona.focus()">
                  <mat-option>
                    <ngx-mat-select-search [ngModel]="f.filtro" (ngModelChange)="filtraPersonas(e, f, $event ?? '')"
                                           placeholderLabel="Buscar persona" ariaLabel="Buscar persona"
                                           noEntriesFoundLabel="Nadie coincide"></ngx-mat-select-search>
                  </mat-option>
                  <mat-option *ngFor="let op of f.opciones; trackBy: trackPersona" [value]="op.idUsuario"
                              [disabled]="e.ocupadas.has(op.idUsuario) && op.idUsuario !== f.usuario.idUsuario">
                    {{ op.usuario }}<span class="parametros-bsc__ocupada"
                          *ngIf="e.ocupadas.has(op.idUsuario) && op.idUsuario !== f.usuario.idUsuario"> (ya en esta área)</span>
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline" class="table-page__field parametros-bsc__usuario-rol"
                              subscriptSizing="dynamic">
                <mat-label>Rol de la persona {{ i + 1 }}</mat-label>
                <mat-select [(ngModel)]="f.usuario.rol">
                  <mat-option *ngFor="let r of roles; trackBy: trackValor" [value]="r.valor">{{ r.texto }}</mat-option>
                </mat-select>
              </mat-form-field>
              <button type="button" class="table-page__action-btn table-page__action-btn--danger" title="Quitar"
                      [id]="'bsc-area-quitar-' + i"
                      [attr.aria-label]="'Quitar a ' + (nombreUsuario(f.usuario) || 'la persona ' + (i + 1)) + ' del área'"
                      (click)="quitarUsuario(i)">
                <span class="material-icons" aria-hidden="true">person_remove</span>
              </button>
            </div>

            <p class="parametros-page__nota" *ngIf="sinResponsable">
              Sin responsable el área no puede abrir su planeación del año.
            </p>

            <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary"
                    id="bsc-area-agregar-usuario" (click)="agregarUsuario()">
              <span class="material-icons" aria-hidden="true">person_add</span>
              Agregar usuario
            </button>
          </div>

          <div class="parametros-bsc__editor-acciones">
            <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary"
                    [disabled]="guardandoArea" (click)="cancelarArea()">
              <span class="material-icons" aria-hidden="true">close</span>
              Cancelar
            </button>
            <button type="button" mat-raised-button class="btn table-page__primary-btn"
                    [disabled]="guardandoArea" (click)="guardarArea()">
              <span class="material-icons" aria-hidden="true">save</span>
              {{ guardandoArea ? "Guardando…" : "Guardar área" }}
            </button>
          </div>
        </fieldset>
      </ng-template>
    </section>

    <!-- ============================ KPI maestro y Fusionar KPI (F7.2) ============================ -->
    <section class="table-page__card parametros-page__bloque" *ngIf="!loading && !error && ciclo && areasConId.length > 0">
      <header class="parametros-page__encabezado">
        <h2>KPI de cada área entre años</h2>
        <p>
          Un KPI es el mismo de un año a otro: así lo compara el comparativo anual. Si al cargar un FOR-011 quedó
          repetido porque ese año se redactó distinto, fusiónalo con el que se conserva. No dependen del año.
        </p>
      </header>

      <div class="parametros-page__grid">
        <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
          <mat-label>Área</mat-label>
          <mat-select [ngModel]="kpiArea" (ngModelChange)="onAreaKpis($event)" [disabled]="fusionando">
            <mat-option *ngFor="let a of areasConId; trackBy: trackArea" [value]="a.idBscArea">
              {{ a.nombre }}{{ a.estatus === "INACTIVO" ? " (inactiva)" : "" }}
            </mat-option>
          </mat-select>
          <mat-hint>Sus KPI activos y retirados, con los años en que aparece cada uno.</mat-hint>
        </mat-form-field>
      </div>

      <div class="table-page__empty" *ngIf="cargandoKpis">
        <span class="material-icons" aria-hidden="true">hourglass_top</span>
        <h3>Consultando los KPI del área</h3>
        <p>Espere un momento.</p>
      </div>

      <div class="table-page__empty" *ngIf="!cargandoKpis && errorKpis">
        <span class="material-icons" aria-hidden="true">error_outline</span>
        <h3>No se pudieron consultar los KPI</h3>
        <p>{{ errorKpis }}</p>
        <button type="button" mat-raised-button class="btn table-page__primary-btn" (click)="consultarKpis()">
          <span class="material-icons" aria-hidden="true">refresh</span>
          Volver a consultar
        </button>
      </div>

      <div class="table-page__empty" *ngIf="!cargandoKpis && !errorKpis && kpisMaestro.length === 0">
        <span class="material-icons" aria-hidden="true">insights</span>
        <h3>El área todavía no tiene KPI</h3>
        <p>Nacen al cargar su FOR-011 o al planear su año.</p>
      </div>

      <ng-container *ngIf="!cargandoKpis && !errorKpis && kpisMaestro.length > 0">
        <div class="table-page__table-wrap">
          <table class="table-page__table">
            <thead>
              <tr>
                <th>KPI</th>
                <th class="parametros-bsc__col-anios">Años</th>
                <th>Estatus</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let k of kpisMaestro; trackBy: trackKpi"
                  [class.is-selected]="k.idKpi === fusion.origen || k.idKpi === fusion.destino">
                <td>
                  <div class="table-page__cell-stack">
                    <strong class="table-page__name">{{ k.objetivo }}</strong>
                    <span class="table-page__subtext" *ngIf="k.indicador">{{ k.indicador }}</span>
                  </div>
                </td>
                <td class="parametros-bsc__col-anios">
                  <div class="parametros-bsc__chips" *ngIf="(k.anios?.length ?? 0) > 0; else sinAnios">
                    <span class="table-page__status-badge is-inactive parametros-bsc__chip" *ngFor="let a of k.anios">{{ a }}</span>
                  </div>
                  <ng-template #sinAnios><span class="table-page__subtext">Sin planeación</span></ng-template>
                </td>
                <td>
                  <div class="parametros-bsc__chips">
                    <span class="table-page__status-badge"
                          [ngClass]="k.estatus === 'RETIRADO' ? 'is-inactive' : 'is-active'">
                      {{ k.estatus === "RETIRADO" ? "Retirado" : "Activo" }}
                    </span>
                    <span class="table-page__status-badge is-pending" *ngIf="k.idKpi === fusion.origen">Se retira</span>
                    <span class="table-page__status-badge is-active" *ngIf="k.idKpi === fusion.destino">Se conserva</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="parametros-bsc__editor">
          <h3 class="parametros-bsc__editor-titulo">Fusionar dos KPI del área</h3>
          <div class="parametros-page__grid">
            <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
              <mat-label>KPI que se retira</mat-label>
              <mat-select [ngModel]="fusion.origen" (ngModelChange)="onOrigen($event)" [disabled]="fusionando">
                <mat-option *ngFor="let op of opcionesOrigen" [value]="op.id" [attr.title]="op.titulo">{{ op.texto }}</mat-option>
              </mat-select>
              <mat-hint>Sus años pasan al otro KPI y este deja de cruzar en las cargas.</mat-hint>
            </mat-form-field>

            <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
              <mat-label>Se fusiona en (se conserva)</mat-label>
              <mat-select [ngModel]="fusion.destino" (ngModelChange)="onDestino($event)"
                          [disabled]="fusionando || fusion.origen == null">
                <mat-option *ngFor="let op of opcionesDestino" [value]="op.id" [disabled]="op.deshabilitado"
                            [attr.title]="op.titulo">
                  {{ op.texto }}
                </mat-option>
              </mat-select>
              <mat-hint>Su redacción queda en todos los años. No puede estar en un año del otro.</mat-hint>
            </mat-form-field>
          </div>

          <output class="parametros-page__nota parametros-bsc__relleno d-block" *ngIf="textoFusion">{{ textoFusion }}</output>

          <div class="parametros-bsc__editor-acciones">
            <button type="button" mat-raised-button class="btn table-page__primary-btn"
                    [disabled]="!puedeFusionar || fusionando" (click)="fusionar()">
              <span class="material-icons" aria-hidden="true">call_merge</span>
              {{ fusionando ? "Fusionando…" : "Fusionar KPI" }}
            </button>
          </div>
        </div>
      </ng-container>
    </section>

    <ng-container *ngIf="!loading && !error && ciclo">
      <!-- ============================ Perfiles con llave ============================ -->
      <section class="table-page__card parametros-page__bloque">
        <header class="parametros-page__encabezado parametros-bsc__encabezado-acciones">
          <div>
            <h2>Quién autoriza y quién administra</h2>
            <p>
              Tienen la llave de autorizar trimestres y planeaciones (Dirección) o la de estos parámetros (Calidad).
              Solo lectura: los perfiles se asignan en Personas › Empleados.
            </p>
          </div>
          <a mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary" [routerLink]="rutaPerfiles">
            <span class="material-icons" aria-hidden="true">manage_accounts</span>
            Administrar perfiles
          </a>
        </header>

        <ul class="parametros-bsc__lista" *ngIf="perfilesConLlave.length > 0; else sinPerfiles">
          <li *ngFor="let p of perfilesConLlave">
            <span class="material-icons" aria-hidden="true">key</span>
            {{ p }}
          </li>
        </ul>
        <ng-template #sinPerfiles>
          <p class="parametros-page__nota parametros-bsc__relleno">Nadie tiene todavía esas llaves en esta empresa.</p>
        </ng-template>
      </section>

      <!-- ============================ Catálogos y formato ============================ -->
      <section class="table-page__card parametros-page__bloque">
        <header class="parametros-page__encabezado">
          <h2>Catálogos y formato</h2>
          <p>
            Las unidades son fijas en esta versión. La versión del FOR-011 es la plantilla con que se exporta el año y
            contra la que se compara cada Excel que se carga.
          </p>
        </header>

        <div class="parametros-page__grid">
          <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
            <mat-label>Versión del formato FOR-011</mat-label>
            <input matInput type="text" [maxlength]="largoVersion" [(ngModel)]="forma.version" [disabled]="cerrado"
                   placeholder="FOR-011 v1.8" aria-label="Versión del formato FOR-011" />
            <mat-hint>Vacía conserva la que tenía el año. Hasta {{ largoVersion }} caracteres.</mat-hint>
          </mat-form-field>
        </div>

        <dl class="parametros-bsc__datos">
          <div>
            <dt>Unidades de meta</dt>
            <dd>
              <span class="table-page__status-badge is-inactive parametros-bsc__chip" *ngFor="let u of unidades">{{ u }}</span>
              <span *ngIf="unidades.length === 0">—</span>
            </dd>
          </div>
        </dl>
      </section>

      <!-- ============================ Cerrar año ============================ -->
      <section class="table-page__card parametros-page__bloque" *ngIf="!heredado">
        <header class="parametros-page__encabezado parametros-bsc__encabezado-acciones">
          <div>
            <h2>Cerrar {{ anio }}</h2>
            <p *ngIf="!cerrado">
              Cuando todas las áreas tengan su Q4 autorizado. Un año cerrado ya no admite captura, importación ni
              cambios de parámetros.
            </p>
            <p *ngIf="cerrado">El año ya está cerrado.</p>
          </div>
          <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary"
                  *ngIf="puedeCerrarAnio" [disabled]="cerrando || guardandoIndicadores" (click)="cerrarAnio()">
            <span class="material-icons" aria-hidden="true">lock</span>
            {{ cerrando ? "Cerrando…" : "Cerrar año" }}
          </button>
        </header>
        <div class="parametros-bsc__relleno"></div>
      </section>
    </ng-container>
  </div>
</div>
